import { render, staticRenderFns } from "./ListagemFornecedor.vue?vue&type=template&id=e6099716&"
import script from "./ListagemFornecedor.vue?vue&type=script&lang=js&"
export * from "./ListagemFornecedor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports